import { usePostPortfolioCommoditiesMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioCommoditiesMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getCommoditiesCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormDefaults";
import {
	type CommoditiesCreateFormOutput,
	getCommoditiesCreateFormSchema,
} from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { mapInvestmentCreateFormToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/mapInvestmentFormToRequest";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateCommoditiesForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioCommoditiesMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getCommoditiesCreateFormSchema(t),
		defaultValues: getCommoditiesCreateFormDefaultValues(),
		mutate: (data: CommoditiesCreateFormOutput, options) => {
			mutate(mapInvestmentCreateFormToRequest(data), options);
		},
		successRoute: Routing.Portfolio.PortfolioAddCommoditiesSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
